/* HIGHABODE draft theme. Shopify prices and native cart lines are authoritative. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const api = path => `${root}${path}`;
  const request = async (method, url, payload) => {
    const options = {method, headers: {Accept: 'application/json'}};
    if (payload !== undefined) { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
    const response = await fetch(url, options);
    let result;
    try { result = await response.json(); } catch { throw new Error('We could not complete this request. Please review your cart before trying again.'); }
    if (!response.ok) {
      const error = new Error(result.description || result.message || 'The cart could not be updated. Please try again.');
      error.httpStatus = response.status;
      throw error;
    }
    return result;
  };
  const post = (url, payload) => request('POST', url, payload);
  const getCart = async () => {
    const result = await request('GET', api('cart.js'));
    if (!Array.isArray(result.items) || typeof result.currency !== 'string') throw new Error('We could not read your cart. Please refresh before trying again.');
    return result;
  };
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-item]')];
    if (!slides.length) return;
    let index = 0;
    const status = gallery.querySelector('[data-gallery-status]');
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const wasHidden = slide.hidden;
        slide.hidden = i !== index;
        if (!wasHidden && slide.hidden) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
        }
      });
      if (status) status.textContent = `${index + 1} of ${slides.length}`;
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    if (slides.length === 1) gallery.querySelectorAll('button').forEach(button => { button.hidden = true; });
    gallery.addEventListener('highabode:select-media', event => {const found = slides.findIndex(slide => slide.dataset.mediaId === String(event.detail.id));if (found >= 0) show(found);});
    const initial = slides.findIndex(slide => slide.dataset.mediaId === gallery.dataset.initialMedia);
    show(initial >= 0 ? initial : 0);
  });
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const configElement = section.querySelector('[data-product-config]');
    const form = section.querySelector('[data-product-form]');
    if (!configElement || !form) return;
    const config = JSON.parse(configElement.textContent);
    const status = form.querySelector('[data-form-status]');
    const button = form.querySelector('[data-add-button]');
    const variantSelect = form.querySelector('[data-variant-select]');
    variantSelect?.addEventListener('change', () => {
      const selected = variantSelect.selectedOptions[0];
      section.querySelector('[data-variant-price]').textContent = selected.dataset.price;
      section.querySelector('[data-variant-sku]').textContent = selected.dataset.sku;
      if (selected.dataset.mediaId) section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('highabode:select-media', {detail: {id: selected.dataset.mediaId}}));
      if (button) {
        button.disabled = selected.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Currently unavailable' : 'Add to cart';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url);
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!config.commerce || !button) return;
      const data = new FormData(form);
      const variantId = Number(data.get('id'));
      const quantity = Number(data.get('quantity'));
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 20 || !Number.isSafeInteger(variantId) || variantId <= 0) {
        status.textContent = 'Choose a quantity between 1 and 20.';
        return;
      }
      const whiteGlove = data.get('delivery_choice') === 'white-glove';
      if (whiteGlove && (!config.whiteGloveEnabled || !config.backendReady || !config.itemEligible || !config.serviceReady || config.servicePrice !== 19900 || config.currency !== 'USD')) {
        status.textContent = 'White-glove eligibility and booking must be confirmed before adding this service.';
        return;
      }
      button.disabled = true;
      status.textContent = 'Adding to your cart…';
      let cartMutationStarted = false;
      let cartAddRejected = false;
      try {
        const items = [{id: variantId, quantity}];
        let instanceId;
        if (whiteGlove) {
          const zip = form.querySelector('[data-delivery-zip]')?.value.trim();
          if (!/^\d{5}$/.test(zip || '')) throw new Error('Enter a five-digit delivery ZIP code.');
          // The trusted app proxy must sign this token. Checkout validation must
          // reject a token if the final checkout ZIP, item, quantity or price differs.
          const before = await getCart();
          if (before.currency !== 'USD') throw new Error('White-glove pricing is available in USD. Refresh your cart before continuing.');
          const proxyPath = config.eligibilityUrl || '/apps/highabode-delivery/eligibility';
          if (!/^\/(?:apps|a|community|tools)\/[a-zA-Z0-9/_-]+$/.test(proxyPath)) throw new Error('White-glove booking is not connected. Please use standard delivery.');
          instanceId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          const eligibility = await post(proxyPath, {variant_id: variantId, quantity, zip, instance_id: instanceId});
          if (eligibility.allowed !== true || eligibility.instance_id !== instanceId || typeof eligibility.eligibility_token !== 'string' || !eligibility.eligibility_token) throw new Error('White-glove delivery is not confirmed for this item and ZIP code.');
          const properties = {_highabode_delivery_token: eligibility.eligibility_token, _highabode_delivery_zip: zip, _highabode_delivery_instance: instanceId};
          items[0].properties = properties;
          items.push({id: config.serviceVariantId, quantity, parent_id: variantId, properties});
        }
        cartMutationStarted = true;
        try {
          await post(config.cartAddUrl, {items});
        } catch (error) {
          cartAddRejected = error.httpStatus >= 400 && error.httpStatus < 500;
          throw error;
        }
        if (whiteGlove) {
          const after = await getCart();
          const matching = after.items.filter(item => item.properties?._highabode_delivery_instance === instanceId);
          const parent = matching.find(item => Number(item.variant_id || item.id) === variantId);
          const child = matching.find(item => Number(item.variant_id || item.id) === config.serviceVariantId);
          if (after.currency !== 'USD' || matching.length !== 2 || !parent || !child || parent.quantity !== quantity || child.quantity !== quantity || child.final_price !== 19900 || child.requires_shipping !== false || child.parent_relationship?.parent_key !== parent.key) throw new Error('The white-glove service in your cart could not be confirmed.');
        }
        window.location.assign(config.cartUrl);
      } catch (error) {
        const cartStateUnconfirmed = cartMutationStarted && !cartAddRejected;
        status.textContent = cartStateUnconfirmed ? 'Your cart may have changed, but this request could not be confirmed. Open your cart to review it before adding this item again.' : (error.message || 'We could not update your cart. Please try again.') + (cartAddRejected ? ' Open your cart to review it before adding this item again.' : '');
        button.disabled = cartStateUnconfirmed;
      }
    });
  });
  const cartForm = document.querySelector('#CartForm');
  if (cartForm) cartForm.addEventListener('submit', async event => {
    if (event.submitter?.name === 'checkout') return; // Server-side validation remains mandatory.
    event.preventDefault();
    const status = cartForm.querySelector('[data-cart-status]');
    const lines = [...cartForm.querySelectorAll('[data-cart-line]')];
    const updates = {};
    try {
      lines.filter(line => line.dataset.isService !== 'true').forEach(parent => {
        const input = parent.querySelector('[data-line-quantity]');
        if (!input) return; // Locked and nested service lines are never rewritten.
        const rawQuantity = input.value.trim();
        if (rawQuantity === '') throw new Error('Enter a quantity between 0 and 20.');
        const quantity = Number(rawQuantity);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > 20) throw new Error('Choose a quantity between 0 and 20.');
        if (quantity !== Number(parent.dataset.quantity)) updates[parent.dataset.key] = quantity;
      });
      if (!Object.keys(updates).length) {status.textContent = 'Your cart is up to date.';return;}
      const current = await getCart();
      if (Object.keys(updates).some(key => !current.items.some(item => item.key === key))) throw new Error('Your cart changed in another page. Refresh before changing quantities.');
      if (Object.keys(updates).some(key => {
        const actual = current.items.find(item => item.key === key);
        const shown = lines.find(line => line.dataset.key === key);
        return actual.instructions?.can_update_quantity === false || (updates[key] === 0 && actual.instructions?.can_remove === false) || actual.quantity !== Number(shown.dataset.quantity);
      })) throw new Error('Your cart changed in another page. Refresh before changing quantities.');
      status.textContent = 'Updating your cart…';
      await post(api('cart/update.js'), {updates});
      window.location.reload();
    } catch (error) { status.textContent = error.message; }
  });
})();
